import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .sl-text-container {
    text-align: center;
    margin: 128px auto 30px;
    width: 100%;
    max-width: 80%;
    h1 {
      line-height: 1.5;
      font-size: 24px;
    }
  }

  .swap-switch {
    text-align: center;
    padding: 20px 0;
    max-width: 1048px;
    margin: auto;
    width: 100%;
    .swap-switch-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 100%;
      border-radius: 4px;
      text-align: center;
      padding: 20px 0;
      max-width: 1048px;
      margin: auto;
      margin-bottom: 50px;
      width: 100%;
      button:last-child {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;
      }
      button:first-child {
        border-top-left-radius: 24px;
        border-bottom-left-radius: 24px;
      }
      button {
        max-width: 180px;
        width: 50%;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: 0 0;
        border: 1px solid #1c2938;
        color: var(--title-color);
      }
      .btn-active {
        background: hsla(0, 0%, 100%, 0.87);
        border: 1px solid transparent;
        color: #12131a;
      }
    }
  }
  .swap-container {
    text-align: center;
    padding: 20px 0;
    max-width: 1048px;
    margin: auto;
    width: 100%;
    margin: -32px;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    .coin-swap {
      margin: 0;
      box-sizing: border-box;
    }
    .text-area {
      text-align: left;
      margin-bottom: 60px;
      h1 {
        line-height: 1.5;
        font-size: 24px;
        text-align: left;
      }
      p {
        margin-top: 20px;
        line-height: 1.5;
        text-align: left;
      }
    }
  }

  .coin-input {
    background-color: var(--prices-background);
    padding: 16px;
    border-radius: 10px;
    z-index: 1;
    position: relative;
    text-align: left;
    &__title {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      justify-content: space-between;
      /* padding: 16px; */
      border-radius: 10px;
      z-index: 1;
      position: relative;
      text-align: left;
      p {
        font-size: 16px;
        line-height: 1.5;
      }
    }
    &__group {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      /* padding: 16px; */
      border-radius: 10px;
      z-index: 1;
      position: relative;
      text-align: left;
      .sl-coinButton {
        z-index: 1;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 38px;
        transition: all 0.2s;
        img {
          width: 28px;
          margin-right: 4px;
        }
        p {
          font-size: 16px;
          font-weight: 500;
          line-height: 1.5;
          color: var(--primaryColor);
        }
      }
      .currencySelected {
        background-color: #404557;

        &:hover {
          background-color: #303547;
        }
      }
      .currencyUnSelected {
        background-color: var(--green);
        &:hover {
          background-color: #004c00;
        }
        p {
          font-weight: bold;
        }
      }
      .sl-input {
        flex: 1 1;
        position: relative;
        padding-left: 8px;
        input {
          color: var(--title-color);
          text-align: right;
          width: 100%;
          position: relative;
          outline: none;
          border: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          /* -webkit-appearance: textfield; */
          background: 0 0;
          box-shadow: none;
          text-align: right;
          color: var(--primaryColor);
          font-size: 18px;
          font-weight: 600;
          /* font-family: inter,sans-serif; */
          padding: 1px 2px;
          writing-mode: horizontal-tb !important;
        }
      }
    }
    .sl-coin-balance {
      display: flex;
      align-items: center;
      justify-content: space-between;
      small {
        font-size: 14px;
        line-height: 1.57;
      }
      span {
        font-size: 14px;
        line-height: 1.57;
      }
    }
  }
  .sl-change-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px auto;
    z-index: 2;
    position: relative;
    img {
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        transform: translateY(-1px);
      }
      width: 40;
      height: 40;
      color: white;
    }
  }
  .sl-action-button {
    margin: 30px 0 10px 0;
    button {
      width: 100%;
    }
  }
  @media (min-width: 450px) {
    .coin-swap {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
    .text-area {
      flex-grow: 0;
      max-width: 100%;
      flex-basis: 100%;
    }
  }
  @media (min-width: 960px) {
    .swap-container {
      flex-wrap: nowrap;
    }
    .coin-swap {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
      padding: 32px;
    }
    .text-area {
      flex-grow: 0;
      max-width: 50%;
      flex-basis: 50%;
      padding: 32px;
      margin-bottom: 60px;
    }
  }
  @media screen and (max-width: 599px) {
    h1 {
      font-size: 30px;
      line-height: 1.1;
    }
  }
  @media screen and (max-width: 959px) {
    .text-area {
      order: -1;
    }
  }
`;
